import { ILabelValuePair } from 'types/shared';
import {
  playListingPriorityEventTypes,
  playListingEventTypes,
} from 'components/notifications/Settings/utils/createNewSubscription';

const getTracks =
  (text: string) =>
  (message: any): boolean =>
    message.entity?.displayName?.toLowerCase().indexOf(text.toLowerCase()) !==
    -1;
const getEventType =
  (text: string) =>
  (item: any): boolean => {
    return (
      (playListingPriorityEventTypes.indexOf(item.eventType) !== -1 &&
        text === 'playlist-priority') ||
      (playListingEventTypes.indexOf(item.eventType) !== -1 &&
        text === 'playlist') ||
      item.eventType?.toLowerCase().indexOf(text.toLowerCase()) !== -1
    );
  };

const getUpdatedNotifications = ({
  items,
  getCondition,
}: {
  items: any;
  getCondition: (mes: any) => any;
}): any => {
  const filteredNotifications = Object.entries(items).reduce(
    (prev: any, [date, messages]: any) => {
      messages.forEach((message: any) => {
        if (getCondition(message)) {
          prev = Object.assign({}, prev, {
            [date]: [].concat(prev[date] ? prev[date] : [], [message] as any),
          });
        }
      });
      return prev;
    },
    {}
  );

  return filteredNotifications;
};

const handleNotifications = ({
  allEvents,
  selectedItem,
  searchValue,
  setNotifications,
}: {
  allEvents: any;
  selectedItem: ILabelValuePair<string> | null;
  searchValue: string;
  setNotifications: (notices: any) => void;
}): any => {
  if (!allEvents) return;

  let notices: any = allEvents;

  if (selectedItem && selectedItem?.value !== 'all') {
    notices = getUpdatedNotifications({
      items: notices,
      getCondition: getEventType(selectedItem?.value),
    });
  }

  if (searchValue.length > 0) {
    notices = getUpdatedNotifications({
      items: notices,
      getCondition: getTracks(searchValue),
    });
  }

  setNotifications(notices);
};

export default handleNotifications;
